module.exports = __webpack_public_path__ + "img/icon_not_support.a9efe11e.svg";